import { useLazyQuery, useMutation } from "@apollo/client/react"; import React, { useEffect, useState } from 'react';
import './generarMinutaGrilla.scss';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { GET_MINUTA_PERIODO_ACTIVO, adaptMinutaPeriodoActivo } from '../../../data/graphQL/queries/GenerarMinuta/getPeriodoMinutaActivo';
import { GET_JUSTIFICACION_PERIODO_FACTURAR, adaptJustificacionPeriodoFacturarArray } from '../../../data/graphQL/queries/GenerarMinuta/getJustificacionPeriodoFacturar';
import { CREATE_MINUTA_MASIVA } from '../../../data/graphQL/mutations/GenerarMinuta/createMinutaMasiva';
import { JUSTIFICAR_MINUTA_MASIVA } from '../../../data/graphQL/mutations/GenerarMinuta/justificarMinutaMasiva';

import moment from 'moment';
import toast from 'react-hot-toast';

export const GenerarMinutaGrillaHeader = ({
  allowedWrite,
  conexionesPendientesFacturar,
  conexionesSeleccionadas,
  filters,
  periodoActivo,
  setPeriodoActivo,
  setRefetchGrilla,
  setGenerateRunning
}) => {
  const descMes = ["", "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
  const [justificaciones, setJustificaciones] = useState([]);
  const [idJustificacionMasiva, setIdJustificacionMasiva] = useState(0);

  const [getPeriodoActivo, { data: periodoData, loading: periodoLoading }] = useLazyQuery(GET_MINUTA_PERIODO_ACTIVO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!periodoData) return;
    setPeriodoActivo(periodoData.periodoMinutaActivo != null ? adaptMinutaPeriodoActivo(periodoData.periodoMinutaActivo) : null);
  }, [periodoData]);


  const [getJustificaciones, { data: dataJustificaciones, loading: justificacionesLoading }] = useLazyQuery(GET_JUSTIFICACION_PERIODO_FACTURAR, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataJustificaciones) return;
    setJustificaciones(adaptJustificacionPeriodoFacturarArray(dataJustificaciones.justificacionPendienteFacturar));
  }, [dataJustificaciones]);


  useEffect(() => {
    if (!periodoLoading)
      getPeriodoActivo();
    if (!justificacionesLoading)
      getJustificaciones();
  }, []);

  // INICIO CREAR MINUTA

  const [createMinutaMasiva, { loading: createMinutaMasivaLoading }] = useMutation(CREATE_MINUTA_MASIVA, {
    onCompleted: (data) => {
      setGenerateRunning(false);
      if (data.createMinutaMasiva.success) {
        toast.success(data.createMinutaMasiva.valorEsperado);
        // recargo la grilla
        setRefetchGrilla(true);
      } else {
        toast.error(data.createMinutaMasiva.valorEsperado);
      }
    }
  });

  const generateInput = () => {
    let lista = [];
    conexionesSeleccionadas.map((conexion) => {
      lista.push({
        idEvaluacion: conexion.idEvaluacion,
        fechaDesdeMin: conexion.fechaDesdeMin,
        fechaHastaMax: conexion.fechaHastaMax,
        precioSAP: conexion.precioSAP
      });
    });
    return lista;
  };

  const handleGenerar = () => {
    if (conexionesSeleccionadas.length > 0) {
      const input = generateInput();
      setGenerateRunning(true);
      createMinutaMasiva({ variables: { minutaInput: input } });
    } else {
      toast.error("Debe seleccionar al menos un registro para generar minutas.");
    }
  };

  // FIN GENERAR MINUTA

  // INICIO JUSTIFICAR

  const [justificarMinutaMasiva, { loading: justificarMinutaMasivaLoading }] = useMutation(JUSTIFICAR_MINUTA_MASIVA, {
    onCompleted: (data) => {
      setGenerateRunning(false);
      if (data.justificarMinutaMasiva.success) {
        toast.success(data.justificarMinutaMasiva.valorEsperado);
        // recargo la grilla y reseteo filtros
        setRefetchGrilla(true);
        setIdJustificacionMasiva(0);
      } else {
        toast.error(data.justificarMinutaMasiva.valorEsperado);
      }
    }
  });

  const isValidJustificacion = () => {
    if (idJustificacionMasiva === 0) {
      toast.error("Debe seleccionar el motivo de Justificación.");
      return false;
    }

    if (conexionesSeleccionadas.length === 0) {
      toast.error("Debe seleccionar al menos un registro para justificar minutas.");
      return false;
    }

    return true;
  };

  const generateInputJustificacion = () => {
    let lista = [];
    conexionesSeleccionadas.map((conexion) => {
      lista.push({
        idEvaluacion: conexion.idEvaluacion,
        fechaDesde: conexion.fechaDesdeMin,
        fechaHasta: conexion.fechaHastaMax,
        codigoCliente: conexion.codClienteSAP
      });
    });
    return {
      idDelegacion: filters.idDelegacion,
      idJustificacion: idJustificacionMasiva,
      listaEvaluacion: lista
    };
  };

  const handleJustificar = () => {
    if (isValidJustificacion()) {
      const input = generateInputJustificacion();
      setGenerateRunning(true);
      justificarMinutaMasiva({ variables: { input: input } });
    }
  };

  // FIN JUSTIFICAR

  return (
    <>
      <div className='top-buttons' style={{ width: '500%' }}>
        <div className='chip-periodo'>
          {
            periodoActivo == null ?
              <strong>- No existe período activo</strong> :
              <strong>{descMes[periodoActivo?.mes]} {periodoActivo?.anio} ({periodoActivo?.fechaDesde != "" ? moment(periodoActivo?.fechaDesde).format("DD/MM/YYYY") : ""} - {periodoActivo?.fechaHasta != "" ? moment(periodoActivo?.fechaHasta).format("DD/MM/YYYY") : ""})</strong>
          }
        </div>
        <FormControl sx={{ backgroundColor: 'white', width: '200px' }} size="small">
          <InputLabel id="select-justificacion">Justificación</InputLabel>
          <Select
            labelId="select-justificacion"
            options={justificaciones}
            label='Justificación'
            onChange={(e) => setIdJustificacionMasiva(e.target.value)}
            value={idJustificacionMasiva}
            name='idJustificacion'
            disabled={
              !allowedWrite ||
              periodoActivo == null ||
              periodoLoading ||
              conexionesPendientesFacturar == null || conexionesPendientesFacturar.length == 0 ||
              conexionesSeleccionadas.length == 0 ||
              createMinutaMasivaLoading
            }>

            {justificaciones && justificaciones.map((justificacion) => {
              return <MenuItem key={justificacion.idJustificacion} value={justificacion.idJustificacion}> {justificacion.justificacion} </MenuItem>;
            })}
          </Select>
        </FormControl>
        &nbsp;&nbsp;
        <CustomButton
          variant='outlined'
          isLoading={justificarMinutaMasivaLoading}
          disabled={
            !allowedWrite ||
            periodoActivo == null ||
            periodoLoading ||
            conexionesPendientesFacturar == null || conexionesPendientesFacturar.length == 0 ||
            conexionesSeleccionadas.length == 0 ||
            createMinutaMasivaLoading
          }
          onClick={handleJustificar}>

          Justificación Masiva
        </CustomButton>
        &nbsp;&nbsp;
        <CustomButton
          isLoading={createMinutaMasivaLoading}
          disabled={
            !allowedWrite ||
            periodoActivo == null ||
            periodoLoading ||
            conexionesPendientesFacturar == null || conexionesPendientesFacturar.length == 0 ||
            conexionesSeleccionadas.length == 0 ||
            justificarMinutaMasivaLoading
          }
          onClick={handleGenerar}>

          Generar Minuta
        </CustomButton>
      </div>
    </>);

};